module.exports = __webpack_public_path__ + "img/emoji_kafei.360d94ed.png";